import { TEMPLATE } from "../../../../../constants"
import { parseDate } from "../../../../../services/util/time"

const {
    // PRETRIP_HISTORY_STATUS_LABEL: statusConfig,
    PRETRIP_HISTORY_STATUS: STATUS
} = TEMPLATE.PRETRIP

export function getLatestDataPerDate(dataReport) {
    return dataReport.reduce((acc, current) => {
        const dateKey = current.date ? current.date.replaceAll('-', '/') : parseDate(current.createdAt)

        const entry = {
            ...current,
            dpid: current.dpid,
            status: current.status,
            driver: current.name,
            plate: current.plate,
            createdAt: current.createdAt,
            note: current.note,
            date: dateKey,
        }

        const existing = acc[dateKey]
        if (!existing || current.createdAt > existing.createdAt) {
            acc[dateKey] = entry
        }

        return acc
    }, {})
}

export function buildDefaultEntry(defaultSource, date) {
    return {
        status: STATUS.MISSING,
        driver: defaultSource.name,
        plate: defaultSource.plate,
        createdAt: defaultSource.createdAt,
        note: defaultSource.note,
        date: parseDate(date ?? defaultSource.createdAt),
    }
}